import React, { useEffect, useRef, useState } from 'react';
import customMarker from '../images/Marker.svg';
import './GoogleMap.css';

// Custom map styling - iPhone Dark Mode Theme
const mapStyles = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#1f2639"  // Dark blue background
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#746855"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#1f2639"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#373d49"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#373d49"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#6b9a76"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#27304A"  // Slightly lighter blue for landscape
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#1f2639"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#6b9a76"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#2a6940"  // Slightly brighter green for parks
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#6b9a76"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#304064"  // Blue roads
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#373d49"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9ca5b3"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#3c4661"  // Slightly lighter for highways
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#1f2835"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#f3d19c"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#2f3948"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#d59563"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#17263c"  // Dark blue for water
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#515c6d"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#17263c"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#225c3e"  // Forest green for schools
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#a5dbb5"  // Light green for school labels
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "hue": "#00ff6b"  // Green hue for school icons
            }
        ]
    }
];

function loadScript(url) {
  return new Promise((resolve, reject) => {
    // Set a timeout to reject if script doesn't load within 10 seconds
    const timeoutId = setTimeout(() => {
      console.error('Google Maps script loading timed out');
      reject(new Error('Script loading timed out'));
    }, 10000);
    
    const existingScript = document.querySelector(`script[src="${url}"]`);
    if (existingScript) {
      console.log('Google Maps script already exists.');
      clearTimeout(timeoutId);
      if (existingScript.getAttribute('data-loaded')) {
        console.log('Google Maps script is already loaded.');
        resolve();
      } else {
        existingScript.onload = () => {
          console.log('Google Maps script loaded.');
          existingScript.setAttribute('data-loaded', 'true');
          resolve();
        };
        existingScript.onerror = (error) => {
          console.error('Error loading Google Maps script:', error);
          clearTimeout(timeoutId);
          reject(error);
        };
      }
      return;
    }
    
    console.log('Creating new Google Maps script element.');
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      console.log('Google Maps script loaded.');
      script.setAttribute('data-loaded', 'true');
      clearTimeout(timeoutId);
      resolve();
    };
    script.onerror = (error) => {
      console.error('Error loading Google Maps script:', error);
      clearTimeout(timeoutId);
      reject(error);
    };
    document.head.appendChild(script);
  });
}

const GoogleMap = ({ addresses }) => {
  const mapRef = useRef(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [userPostcode, setUserPostcode] = useState('');
  const [map, setMap] = useState(null);
  const [directionsService, setDirectionsService] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);
  const [isRoutingActive, setIsRoutingActive] = useState(false);
  const [routeInfo, setRouteInfo] = useState(null);
  
  // Debug output for props
  useEffect(() => {
    console.log('GoogleMap component mounted with addresses:', addresses);
    return () => {
      console.log('GoogleMap component unmounted');
    };
  }, [addresses]);

  useEffect(() => {
    const loadGoogleMapsScript = async () => {
      try {
        console.log('Loading Google Maps script...');
        await loadScript(`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&async=true`);
        setIsScriptLoaded(true);
        setError(null);
        console.log('Google Maps script loaded successfully.');
      } catch (error) {
        console.error('Error loading Google Maps script:', error);
        // More specific error handling
        if (error.message && error.message.includes('timeout')) {
          setError('Google Maps is taking too long to load. Please check your internet connection.');
        } else if (window.google && window.google.maps && window.google.maps.places === undefined) {
          setError('Google Maps Places library failed to load. The API key may have Places API disabled.');
        } else if (error.message && error.message.includes('RefererNotAllowedMapError')) {
          setError('Google Maps API key is restricted to specific domains.');
        } else if (error.message && error.message.includes('InvalidKeyMapError')) {
          setError('Invalid Google Maps API key.');
        } else if (error.message && error.message.includes('MissingKeyMapError')) {
          setError('Missing Google Maps API key.');
        } else if (error.message && error.message.includes('RequestDenied')) {
          setError('Google Maps request was denied. This could be due to billing issues or API restrictions.');
        } else {
          setError('Failed to load Google Maps. Please try again later.');
        }
      }
    };

    loadGoogleMapsScript();
  }, []);

  useEffect(() => {
    if (!isScriptLoaded || !addresses || addresses.length === 0) {
      console.log('Script not loaded or addresses not available. Skipping map initialization.');
      return;
    }

    console.log('Initializing map with addresses:', addresses);
    const initializeMap = () => {
      try {
        if (!window.google || !window.google.maps) {
          console.error('Google Maps API is not available.');
          setError('Google Maps API is not available');
          return;
        }
        
        console.log('Google Maps API is available.');
        const newMap = new window.google.maps.Map(mapRef.current, {
          center: { lat: 0, lng: 0 },
          zoom: 16, // Increased zoom level for better POI visibility
          disableDefaultUI: true, // Hide all UI controls
          zoomControl: true, // Only show zoom controls
          styles: mapStyles // Apply custom map styling
        });
        
        // Add error listener for map rendering issues
        window.google.maps.event.addListenerOnce(newMap, 'idle', () => {
          console.log('Map fully loaded and rendered.');
        });
        
        window.google.maps.event.addListenerOnce(newMap, 'error', (e) => {
          console.error('Error rendering map:', e);
          setError('Error rendering map. This could be due to an issue with map styles or rendering.');
        });
        
        // Initialize directions services
        const newDirectionsService = new window.google.maps.DirectionsService();
        const newDirectionsRenderer = new window.google.maps.DirectionsRenderer({
          map: newMap,
          suppressMarkers: false,
          polylineOptions: {
            strokeColor: '#0ab3d8', // Match app color
            strokeWeight: 5
          }
        });
        
        setMap(newMap);
        setDirectionsService(newDirectionsService);
        setDirectionsRenderer(newDirectionsRenderer);

        const bounds = new window.google.maps.LatLngBounds();
        const geocoder = new window.google.maps.Geocoder();

        addresses.forEach((address, index) => {
          geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results[0]) {
              console.log('Geocoding successful:', results[0].geometry.location.toString());
              const location = results[0].geometry.location;

              // Only add marker if not showing directions
              if (!isRoutingActive) {
                const marker = new window.google.maps.Marker({
                  map: newMap,
                  position: location,
                  animation: window.google.maps.Animation.DROP,
                  icon: {
                    url: customMarker,
                    scaledSize: new window.google.maps.Size(50, 50),
                  }
                });
                console.log('Marker added to map.');
              }

              if (addresses.length > 1) {
                bounds.extend(location);
                newMap.fitBounds(bounds);
              } else {
                newMap.setCenter(location);
                newMap.setZoom(16); // Increased zoom level for better POI visibility
              }
            } else {
              console.error('Geocode was not successful for the following reason: ' + status);
              // More specific geocoding error messages
              switch(status) {
                case 'ZERO_RESULTS':
                  setError(`Unable to find the location: ${address}. Please check the address.`);
                  break;
                case 'OVER_QUERY_LIMIT':
                  setError('Google Maps query limit exceeded. Please try again later.');
                  break;
                case 'REQUEST_DENIED':
                  setError('Google Maps request was denied. The API key may be restricted.');
                  break;
                case 'INVALID_REQUEST':
                  setError('Invalid request. Please check the address format.');
                  break;
                case 'UNKNOWN_ERROR':
                  setError('An unknown error occurred. Please try again later.');
                  break;
                default:
                  setError(`Geocoding error: ${status}`);
              }
            }
          });
        });
      } catch (error) {
        console.error('Error initializing map:', error);
        setError('Failed to initialize map. Please try again later.');
      }
    };

    initializeMap();
  }, [isScriptLoaded, addresses]);

  // Reset map when routing is deactivated
  useEffect(() => {
    if (!isRoutingActive && map && addresses && addresses.length > 0) {
      const geocoder = new window.google.maps.Geocoder();
      
      // Clear directions
      if (directionsRenderer) {
        directionsRenderer.setMap(null);
        directionsRenderer.setMap(map);
      }
      
      // Reset route info
      setRouteInfo(null);
      
      // Re-center map on venue
      geocoder.geocode({ address: addresses[0] }, (results, status) => {
        if (status === 'OK' && results[0]) {
          const location = results[0].geometry.location;
          
          // Re-add the marker
          new window.google.maps.Marker({
            map: map,
            position: location,
            animation: window.google.maps.Animation.DROP,
            icon: {
              url: customMarker,
              scaledSize: new window.google.maps.Size(50, 50),
            }
          });
          
          map.setCenter(location);
          map.setZoom(16); // Increased zoom level for better POI visibility
        }
      });
    }
  }, [isRoutingActive, map, addresses, directionsRenderer]);

  const handleGetDirections = (e) => {
    e.preventDefault();
    
    if (!map || !directionsService || !directionsRenderer || !addresses || addresses.length === 0 || !userPostcode) {
      setError('Unable to get directions. Please try again later.');
      return;
    }
    
    setIsRoutingActive(true);
    
    const destination = addresses[0];
    const origin = userPostcode;
    
    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: window.google.maps.UnitSystem.IMPERIAL, // Ensure distance is in miles
      },
      (response, status) => {
        if (status === 'OK') {
          directionsRenderer.setDirections(response);
          
          // Extract route information
          const route = response.routes[0];
          if (route && route.legs && route.legs[0]) {
            const leg = route.legs[0];
            setRouteInfo({
              distance: leg.distance.text,
              duration: leg.duration.text,
              startAddress: leg.start_address,
              endAddress: leg.end_address
            });
          }
          
          setError(null);
        } else {
          console.error('Directions request failed due to', status);
          setError(`Unable to find route: ${status}. Please check your postcode and try again.`);
          setIsRoutingActive(false);
        }
      }
    );
  };
  
  const handleClearDirections = () => {
    setIsRoutingActive(false);
    setUserPostcode('');
  };

  return (
    <div>
      <div className="map-container" ref={mapRef} style={{ width: '100%', height: '400px' }}>
        {!isScriptLoaded && !error && (
          <div style={{ 
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.05)',
            color: '#0ab3d8',
            padding: '1rem',
            textAlign: 'center',
            borderRadius: '8px'
          }}>
            <div>
              <div style={{ marginBottom: '1rem' }}>Loading map...</div>
              <div className="loading-spinner"></div>
            </div>
          </div>
        )}
        {error && (
          <div style={{ 
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.05)',
            color: '#f44336',
            padding: '1rem',
            textAlign: 'center',
            borderRadius: '8px'
          }}>
            {error}
          </div>
        )}
      </div>
      
      <div className="directions-container">
        <form onSubmit={handleGetDirections}>
          <label htmlFor="userPostcode">Get Driving Directions</label>
          
          <div className="directions-input-group">
            <input 
              type="text" 
              id="userPostcode"
              value={userPostcode}
              onChange={(e) => setUserPostcode(e.target.value)}
              placeholder="Enter your postcode"
              required
            />
            {isRoutingActive ? (
              <button type="button" onClick={handleClearDirections} className="clear-button">Clear</button>
            ) : (
              <button type="submit">Go</button>
            )}
          </div>
          
          {routeInfo && (
            <div className="route-info">
              <div className="route-info-item">
                <span className="route-info-icon">📍</span>
                <div className="route-info-text">
                  <span className="route-info-label">Distance:</span>
                  <span className="route-info-value">{routeInfo.distance}</span>
                </div>
              </div>
              
              <div className="route-info-item">
                <span className="route-info-icon">⏱️</span>
                <div className="route-info-text">
                  <span className="route-info-label">Travel Time:</span>
                  <span className="route-info-value">{routeInfo.duration}</span>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default GoogleMap; 